import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RouteDataService } from '@services/route-data/route-data.service';
import { DetailsRunningTransactionDialogContentComponent } from './details-running-transaction-dialog-content/details-running-transaction-dialog-content.component';

@Component({
  selector: 'app-details-transaction-dialog',
  template: ''
})
export class DetailsRunningTransactionDialogComponent implements OnInit {

  public isOperatorView: boolean;

  constructor(public dialog: NgbModal, private activatedRoute: ActivatedRoute, private routeDataService: RouteDataService, private router: Router) { }

  ngOnInit() {
    this.activatedRoute.paramMap.subscribe(params => {
      this.routeDataService.params = this.activatedRoute.snapshot.params;
      this.openDialog();
    });
  }

  openDialog(): void {
    var customerId = this.activatedRoute.parent.parent.snapshot.params.key;
    const dialogRef = this.dialog.open(DetailsRunningTransactionDialogContentComponent, { size: 'lg', centered: true, backdrop: 'static', keyboard: false });

    dialogRef.componentInstance.customerId = customerId;

    dialogRef.result.then((result) => {
      this.router.navigate(['../'], { relativeTo: this.activatedRoute });
    }, (backdrop) => {
      this.router.navigate(['../'], { relativeTo: this.activatedRoute });
    });
  }

}
